type EitherResult<T> = { result: T; error: null } | { result: null; error: Error }

export async function tryAsync<T>(fn: () => Promise<T>): Promise<EitherResult<T>> {
  try {
    const result = await fn()
    return { result, error: null }
  } catch (error) {
    if (error instanceof Error) {
      return { result: null, error }
    }
    return {
      result: null,
      error: new Error('Unknown error')
    }
  }
}
